import React from 'react';
import { NavigationContainer } from '@react-navigation/native';

import { Provider as ConcertProvider } from './context/ConcertContext';
import { Provider as NewsProvider } from './context/NewsContext';
import { Provider as ArtistsProvider } from './context/ArtistsContext';
import './navigators/MainNavigator';
import MainNavigator from './navigators/MainNavigator';
import Loading from './components/Loading';

import {
  useFonts,
  MPLUS1p_100Thin,
  MPLUS1p_300Light,
  MPLUS1p_400Regular,
  MPLUS1p_500Medium,
  MPLUS1p_700Bold,
  MPLUS1p_800ExtraBold,
  MPLUS1p_900Black,
} from '@expo-google-fonts/m-plus-1p';

export default function App() {
  let [fontsLoaded] = useFonts({
    MPLUS1p_100Thin,
    MPLUS1p_300Light,
    MPLUS1p_400Regular,
    MPLUS1p_500Medium,
    MPLUS1p_700Bold,
    MPLUS1p_800ExtraBold,
    MPLUS1p_900Black,
  });

  if (!fontsLoaded) {
    return <Loading />;
  }

  return (
    <ArtistsProvider>
      <NewsProvider>
        <ConcertProvider>
          <NavigationContainer>
            <MainNavigator />
          </NavigationContainer>
        </ConcertProvider>
      </NewsProvider>
    </ArtistsProvider>
  );
}
